export default "__VITE_ASSET__D2vro1_w__"